<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.posbranchmanagement') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <base-table
        v-else
        hidePagination
      >
        <template #thead>
          <thead>
            <tr>
              <th>{{ $t('message.posbranchname') }}</th>
              <th>{{ $t('message.posbranchnameshort') }}</th>
              <th>{{ $t('message.posbranchcountingstrock') }}</th>
              <th>{{ $t('message.assignproducts') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="branches.length === 0"
                colspan="4"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(branch, index) in branches"
              :key="index"
            >
              <td>
                <router-link
                  :to="{
                    name: 'PosBranchEdit',
                    query: {
                      id: branch.branchId,
                      name: branch.name,
                    }
                }">
                  {{ branch.name }}
                </router-link>
              </td>
              <td>{{ branch.nameShort }}</td>
              <td>{{ branch.whName }}</td>
              <td>{{ branch.assignProducts.length }}</td>
            </tr>
          </tbody>
        </template>
      </base-table>

    </div>

  </div>
</template>

<script>
import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [userPermissionMixin],
  data () {
    return {
      ready: true,
      query: {
        page: this.$route.query.page || 1,
      },
    }
  },
  computed: {
    branches () {
      return this.$store.state.posBranch.branches
    },
  },
  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.pos.title'),
      current: {
        app_name: 'pos',
        app_id: 1,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 3,
      submenuAtIdx: 0,
    })
  },
  created () {
    this.fetchData()
  },
  destroyed () {
    this.leavePage(this.$Progress)
  },
  methods: {
    async fetchData () {
      this.ready = false
      await this.$store.dispatch('getPosBranches')
      this.ready = true
      this.showFinish(this.$Progress)
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/pos/branch/All.vue